'use client';
import { Container as SharedContainer } from '@launchstore/shared-puck';
import type { ContainerProps } from '@launchstore/shared-puck';
export const Container: any = SharedContainer;
export type { ContainerProps };
export default Container;
